import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

var TreeViewIcon = function TreeViewIcon(_ref) {
  var icon = _ref.icon;

  var classes = classNames('icon node-icon indent', icon);
  return React.createElement('span', { className: classes });
};

TreeViewIcon.propTypes = {
  icon: PropTypes.string
};

TreeViewIcon.defaultProps = {
  icon: 'fa fa-folder'
};

export default TreeViewIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/TreeView/TreeViewIcon.js
// module id = 350
// module chunks = 0